/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import React from "react"
import { ExternalLink } from "./ExternalLink"
import { NavLink } from "react-router-dom"

interface IConditionalLinkProps {
  to?: string
  href?: string
  children: React.ReactNode
  onClick?: () => void
  className?: string
  disabled?: boolean
  exact?: boolean
  target?: string
  style?: any
}

export function ConditionalLink({
  to,
  href,
  children,
  disabled,
  target,
  ...props
}: IConditionalLinkProps) {
  if (disabled) {
    const { onClick, ...rest } = props
    return (
      <span
        css={css`
          cursor: not-allowed;
        `}
        {...rest}
      >
        {children}
      </span>
    )
  }
  if (href) {
    return (
      <ExternalLink to={href} {...props}>
        {children}
      </ExternalLink>
    )
  }

  if (!to) {
    return <a {...props}>{children}</a>
  }

  if (to.startsWith("http")) {
    return (
      <ExternalLink to={to} {...props}>
        {children}
      </ExternalLink>
    )
  }
  return (
    <NavLink to={to} {...props} target={target}>
      {children}
    </NavLink>
  )
}
